import { PLANNING_BOOK_LEDGER } from 'Features/DownloadDataModal/DownloadData.constants'

export const FILE_NAME = [
  'Work Centre Outputs',
  'SupplyVue Plan',
  'DRP Outputs',
  'DRP Outputs (Pivot)',
  'Constrained DRP',
].map((value) => ({ key: value, value }))
// Offered beside DRP Outputs on V2 plans whose ledger GET answers 200 (US149971).
export const FILE_NAME_WITH_LEDGER = FILE_NAME.flatMap((item) =>
  item.value === 'DRP Outputs (Pivot)'
    ? [item, { key: PLANNING_BOOK_LEDGER, value: PLANNING_BOOK_LEDGER }]
    : [item]
)

export const FILE_VERSION = ['Constrained', 'Unconstrained']
export const INITIAL_FILE_VERSION = ['Constrained']
export const INITIAL_FILE_FORMAT = 'csv'
export const FILE_FORMATS = ['csv', 'xlxs'].map((value) => ({
  key: value,
  value,
}))

export const KEY_FIGURES_ARRAY = [
  '01 Week starting inventory',
  '02 Week starting inventory in days',
  '03 Physical week starting inventory',
  '04 Forecast demand signal',
  '05 Open sales orders',
  '06 Replenishment plan dispatch',
  '07 Minimum week inventory',
  '08 Physical minimum week inventory',
  '09 Stock in transit arrival',
  '10 Excess base stock',
  '11 Production volume arrival',
  '12 End of week inventory',
  '13 End of week inventory in days',
  '14 Physical end of week inventory',
  '15 Target week close inventory',
  '16 Safety stock volume',
  '17 Safety stock policy (days)',
  '18 Safety stock policy (max)',
  '19 Safety stock policy (min)',
  '20 Minimum inventory in days',
  '21 Minimum inventory percent of safety stock',
  '22 Average weekly demand',
  '23 Deployment lead time',
  '24 Replenishment minimum order quantity',
  '25 Replenishment minimum order increment',
]

export const SET_FILE_NAME = 'SET_FILE_NAME'
export const SET_FILE_VERSION = 'SET_FILE_VERSION'
export const SET_KEY_FIGURES = 'SET_KEY_FIGURES'
export const SET_WORKCENTRES = 'SET_WORKCENTRES'
export const SET_FILE_FORMAT = 'SET_FILE_FORMAT'
